<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Notes" />
      <h2>Notes</h2>
      <flash-messages />
    </template>
    
    <template v-slot:breadcrumbs>
      <BreadCrumbs activeItem="Notes" :crumbs="{ home: 'Dashboard' }"/>
    </template>
    
    <template v-slot:default>
      <DataTable :value="notes" :paginator="true" :rows="50" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
        paginatorPosition="both" 
        :rowsPerPageOptions="[10, 20, 50, 100]" 
        sortField="date" :sortOrder="-1"
        stateStorage="local" stateKey="admin-notes-index" dataKey="id"
        class="p-datatable-sm admin-datatable" tableClass="border-left border-right border-bottom">
          <template #paginatorLeft>
            {{ notes.length }} Notes
          </template>
          <Column field="by" header="By" :sortable="true">
            <template #body="slotProps">
              {{ slotProps.data.by.company_name }} ({{ slotProps.data.by.first_name }} {{ slotProps.data.by.last_name }})
            </template>
          </Column>
          <Column field="desc" header="Item" :sortable="true">
            <template #body="slotProps">
              <inertia-link :href="route(slotProps.data.link[0], slotProps.data.link[1])" v-if="slotProps.data.link">{{ slotProps.data.desc }}</inertia-link>
              <span v-else>
                {{ slotProps.data.desc }}
              </span>
            </template>
          </Column>
          <Column field="date_sent" header="Date" :sortable="true">
            <template #body="slotProps">
              {{ moment(slotProps.data.date_sent).format('M/D/YY h:mm A') }}
              {{ slotProps.data.is_error ? "ERROR" : "" }}
            </template>
          </Column>
          <Column field="content" header="Content" :sortable="true"></Column>
      </DataTable>
    </template>
  </layout>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Admin/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchFilter from '@/Shared/SearchFilter'

  import FlashMessages from '@/Shared/FlashMessages'
  import moment from 'moment'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  export default {
    components: {
      Icon,
      SearchFilter,
      Layout,
      FlashMessages,
      BreadCrumbs
    },
    props: {
      notes: Array
    },
    data() {
      return {
        searchText: this.query,
        searchStatus: this.selectedStatus
      }
    },
    created() {
      this.moment = moment
    },
    methods: {
      search() {
        this.$inertia.get(this.route('admin.orders'),{
          query: this.searchText,
          status: this.searchStatus
        });
      },
      reset() {
        this.form = mapValues(this.form, () => null)
      },
      statusFilter(e) {
        this.$inertia.get(this.route('admin.orders'), {
          query: this.searchText,
          status: this.searchStatus
        });
      },
    },
  }
</script>
